import { createLookupHook } from "./createLookupHook";


export const useVerificationLookups =
  createLookupHook<unknown>(
    "verification",
    "/lookups/verification"
  );